import React from 'react'

import {
  Layout,
  Intro,
  Showcase,
  SectionTitle,
  Header,
} from '../../../../components'

import './style.scss'
import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      >
        <Intro>
          <p>
            Radios are a type of form input that allows the user to select a
            single option from a given list. To allow the user to select
            multiple options, use the Checkbox component. Radio buttons can be
            used with or without a container.
          </p>
        </Intro>
        <SectionTitle>Variants</SectionTitle>
        <Showcase
          site={data.site}
          title="Radio buttons without container"
          text={
            <p>
              Use this radio button to achieve a cleaner layout. In addition to
              the default state, this variant has hover, focus, select, error
              and disable states. Each state affects the radio input. Some
              states also affect the text label.
            </p>
          }
        >
          <div class="c-radio-group">
            <div class="c-radio__container--none">
              <input type="radio" name="option" id="option1" />
              <label htmlFor="option1">Option 1</label>
            </div>
            <div class="c-radio__container--none">
              <input type="radio" name="option" id="option2" />
              <label htmlFor="option2">Option 2</label>
            </div>
            <div class="c-radio__container--none">
              <input type="radio" name="option" id="option3" />
              <label htmlFor="option3">Option 3</label>
            </div>
          </div>
        </Showcase>
        <Showcase
          site={data.site}
          title="Radio with Container"
          text={
            <p>
              Use this variant to distinguish a list of options in a busier
              layout. Options are individually delineated and stacked in a
              stroked container. In addition to the default state, this
              variant has hover, focus, select, error and disable states. Each
              state affects the radio input. Some states also affect the
              container and text label.
            </p>
          }
        >
          <div class="c-radio-group">
            <div class="c-radio__container">
              <input type="radio" name="container" id="option1-container" />
              <label htmlFor="option1-container">Option 1</label>
            </div>
            <div class="c-radio__container">
              <input type="radio" name="container" id="option2-container" />
              <label htmlFor="option2-container">Option 2</label>
            </div>
            <div class="c-radio__container">
              <input type="radio" name="container" id="option3-container" />
              <label htmlFor="option3-container">Option 3</label>
            </div>
          </div>
        </Showcase>
        <hr />
        <SectionTitle>Microcopy</SectionTitle>
        <p>
          Text labels can be full sentences or fragments, but stay consistent
          within the same list. If fragments, all options should use the same
          part of speech (e.g. all nouns or all verbs) rather than mixing. Use
          sentence case with no end punctuation, unless the text is a question.
        </p>
      </Layout>
    </>
  )
}
